export const HttpAlarmConstants = {
	AlarmDecoderResponseId: 0,
	AutoGeneratedResponseId: -1
} as const
